<template>
  <div
    class="decrypt-img"
    :class="{ 'is-draggable': draggable }"
    @dragstart.capture="onDragStart"
  >
    <el-image
      class="decrypt-img"
      v-if="decryptBlob"
      :src="decryptBlob"
      :preview-src-list="previewSrcList"
      fit="contain"
      @load="onImgLoad"
      v-bind="$attrs"
    ></el-image>
  </div>
</template>

<script>
import videoApi from "@/api/videoManagement";

export default {
  name: "LongText",
  props: ["src", "origin", "iPreviewSrcList", "draggable"],
  emit: ["load"],
  data() {
    return {
      decryptBlob: null,
      fileBlob: null,
      fileExt: "png",
    };
  },
  computed: {
    previewSrcList() {
      if (this.iPreviewSrcList) return this.iPreviewSrcList;
      if (this.decryptBlob) return [this.decryptBlob];
      return [];
    },
  },
  watch: {
    src: {
      async handler(val) {
        if (
          this.decryptBlob &&
          typeof this.decryptBlob === "string" &&
          this.decryptBlob.startsWith("blob:")
        ) {
          URL.revokeObjectURL(this.decryptBlob);
        }
        this.fileBlob = null;
        this.decryptBlob = null;
        if (!val) return;
        if (this.origin) {
          this.decryptBlob = this.src;
          return;
        }
        try {
          const result = await videoApi.imgDecyptApi(val);
          this.decryptBlob = result.url;
          this.fileBlob = result.blob;
          this.fileExt = result.ext;
        } catch (error) {
          console.error("图片解密失败:", error);
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    if (
      this.decryptBlob &&
      typeof this.decryptBlob === "string" &&
      this.decryptBlob.startsWith("blob:")
    ) {
      URL.revokeObjectURL(this.decryptBlob);
    }
  },
  methods: {
    getDragFilename() {
      if (this.src) {
        const name = this.src.split("/").pop();
        if (name && name.includes(".")) {
          return name.split("?")[0];
        }
      }
      return `image_${Date.now()}.${this.fileExt}`;
    },
    onDragStart(e) {
      if (!this.draggable) return;
      if (!this.fileBlob) {
        e.preventDefault();
        return;
      }
      const filename = this.getDragFilename();
      const file = new File([this.fileBlob], filename, {
        type: this.fileBlob.type,
      });
      e.dataTransfer.effectAllowed = "copy";

      const img = e.target.closest("img") || this.$el.querySelector("img");
      if (img && img.complete && img.naturalWidth > 0) {
        const rect = img.getBoundingClientRect();
        e.dataTransfer.setDragImage(
          img,
          e.clientX - rect.left,
          e.clientY - rect.top
        );
      }

      if (e.dataTransfer.items) {
        e.dataTransfer.items.add(file);
      }
      if (this.decryptBlob) {
        e.dataTransfer.setData(
          "DownloadURL",
          `${file.type}:${filename}:${this.decryptBlob}`
        );
      }
    },
    onImgLoad(e) {
      this.$emit("load", {
        event: e,
        blob: this.decryptBlob,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.decrypt-img {
  width: 100%;
  height: 100%;

  &.is-draggable {
    cursor: grab;

    &:active {
      cursor: grabbing;
    }
  }
}
</style>
